import { render, staticRenderFns } from "./ApplyDetail.vue?vue&type=template&id=efcb13a8&scoped=true"
import script from "./ApplyDetail.vue?vue&type=script&lang=ts"
export * from "./ApplyDetail.vue?vue&type=script&lang=ts"
import style0 from "./ApplyDetail.vue?vue&type=style&index=0&id=efcb13a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcb13a8",
  null
  
)

export default component.exports